/**
 * Checks if an object is empty.
 * @param {Object} obj The object to check.
 * @returns {boolean} Returns true if the object is empty, otherwise returns false.
 */
export function isEmptyObject(obj) {
  if (!obj) return true;
  return Object.keys(obj).length === 0;
}

/**
 * Checks if a variable is a valid non-empty string.
 * @param {any} variable The variable to check.
 * @returns {boolean} Returns true if the variable is a valid non-empty string, otherwise returns false.
 */
export function isValidString(variable) {
  return typeof variable === 'string' && variable.trim() !== '';
}

export function getKeyByValue(obj, value, isSubstring = false) {
  // eslint-disable-next-line no-unused-vars
  const entry = Object.entries(obj).find(([_, values]) => {
    if (isSubstring) {
      const result = values.some(v => v.includes(value));
      if (result) {
        return true;
      }
      let newValue = null;
      const matches = value.match(/\d+/g);
      if (matches && matches.length > 0) {
        const searchNumber = matches[0];

        const matchedOption = values.find((option) => {
          const matchOption = option.match(/\d+/g);

          if (matchOption && matchOption.length > 1) {
            const optionNumber = matchOption[1];

            return option === value.replace(searchNumber, optionNumber) ||
                (optionNumber === searchNumber && option === value);
          }

          return false;
        });

        newValue = matchedOption || values[0];
      }
      return newValue && values.some(v => v.includes(newValue));
    }
    return values.includes(value);
  });
  return entry ? entry[0] : null;
}

export function appendObjectToFormData(obj, formData, parentKey = '') {
  Object.entries(obj).forEach(([key, value]) => {
    const fieldKey = parentKey ? `${parentKey}[${key}]` : key;

    if (value instanceof File) {
      formData.append(fieldKey, value);
    } else if (value instanceof Object && !(value instanceof Date)) {
      appendObjectToFormData(value, formData, fieldKey);
    } else {
      formData.append(fieldKey, value == null ? '' : value);
    }
  });
}

export function compareFormData(Obj = {}, fieldChange = { value: undefined, name: undefined }) {
  const changes = {};

  const allKeys = new Set([...Object.keys(Obj)]);

  Object.keys(allKeys).forEach((key) => {
    const oldValue = Obj[key];

    if (typeof oldValue === 'object' && oldValue !== null) {
      const nestedChanges = compareFormData(oldValue, fieldChange);
      Object.assign(changes, nestedChanges);
    } else if (oldValue !== fieldChange.value && key === fieldChange.name) {
      if (oldValue) {
        changes[key] = `${key}: ${oldValue} --> ${fieldChange.value}`;
      } else {
        changes[key] = `${key} --> ${fieldChange.value}`;
      }
    }
  });
  return changes;
}

export function mergeFields(target = {}, source = {}) {
  const newTarget = { ...target };
  const newSource = { ...source };
  Object.keys(newSource).forEach((key) => {
    if (newSource.hasOwn(newSource, key) && newSource[key] !== null && newSource[key] !== undefined) {
      if (newTarget.hasOwn(newTarget, key)) {
        newTarget[key] = newSource[key];
      }
    }
  });
  return newTarget;
}

export default {
  isEmptyObject,
  isValidString,
  getKeyByValue,
  appendObjectToFormData,
  compareFormData,
  mergeFields,
};



// WEBPACK FOOTER //
// ./src/utils/helper.js